import { headingVariants } from './Heading.cva';

export interface HeadingProps {
  className?: string;
  intent: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';
  padding?: 'sm' | 'md' | 'base' | 'noPadding';
  shouldTruncate?: boolean;
  children: React.ReactNode;
}

export function Heading({
  className,
  intent,
  padding = 'base',
  shouldTruncate = false,
  children,
}: HeadingProps) {
  const Element = intent || 'h2';

  return (
    <Element
      className={headingVariants({
        intent,
        className,
        padding,
        shouldTruncate,
      })}
    >
      {children}
    </Element>
  );
}

export default Heading;
